<template>
  <div>
    <div style="margin-top: 8%"></div>
    <el-row :gutter="20">
      <el-col :span="24">

        <el-upload
            class="upload-demo"
            ref="word_upload"
            :http-request="uploadAvatar"
            drag
            action="#"
            :limit="1"
            accept=".docx"

            :on-exceed="handleExceed"
            :auto-upload="false"
        >
          <el-icon class="el-icon--upload">
            <upload-filled/>
          </el-icon>
          <div class="el-upload__text">
            将文件拖到此处，或 <em>点击上传</em>
          </div>
          <template #tip>
            <div class="el-upload__tip">
              只能上传.DOCX文件
            </div>
          </template>
        </el-upload>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <!--        <el-button :loading="load2" type="primary" @click="question_query">开始作答</el-button>-->
        <el-button :loading="load1" type="primary" @click="btnSubmit">开始出题</el-button>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div>
          <el-link :href="url_word" :disabled="download_show" type="primary" target="_blank">Word下载</el-link>&nbsp;&nbsp;&nbsp;&nbsp;
          <el-link :href="url_excel" :disabled="download_show" type="primary" target="_blank">Excel下载</el-link>
          <!--          <el-link href="http://152.136.13.118:8081/file_download/0/1676979576924/asdas/" type="primary" target="_blank">test下载</el-link>-->
        </div>

      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <span>
          {{ file_progress }}
        </span>
      </el-col>
    </el-row>


  </div>
  <div style="margin-top: 18%">
    <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备16045889号-6</a>
  </div>
</template>

<script>
import {ref} from 'vue'
import axios from 'axios'
import {ElMessageBox, genFileId} from 'element-plus'


export default {
  name: "DashboardView",
  setup() {
    //const base_url = 'http://127.0.0.1:8000';
    const base_url = 'http://152.136.13.118:8081';
    const problem = ref('');
    const answer = ref('');
    const file_input = ref(null);
    const word_upload = ref(null);
    const intervalId = ref(null);
    const title_msg = ref('Loading...');
    const stamp = ref('');
    const url_word = ref('');
    const url_excel = ref('');
    const download_show = ref(true);
    const load1 = ref(false);
    const file_progress = ref('');

    const handleExceed = (files) => {
      word_upload.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      word_upload.value.handleStart(file);
    };

    const btnSubmit = () => {
      word_upload.value.submit();
    };

    const uploadAvatar = (data) => {
      if (data.file.type.indexOf('word') === -1) {
        ElMessageBox.alert('请导入word文件！', 'success', {
          confirmButtonText: '确定',
        });
        return;
      }
      file_input.value = data.file;
      question_query();
    };

    const question_query = async () => {

      if (file_input.value == null) {
        ElMessageBox.alert('请导入.DOCX文件！', 'success', {
          confirmButtonText: '确定',
        });
        return;
      }

      download_show.value = true;

      stamp.value = Date.now().toString();
      const time1 = parseInt(Date.now());
      load1.value = true;
      const name1 = file_input.value.name.substring(0, file_input.value.name.lastIndexOf("."))

      url_word.value = base_url + '/file_download/0/' + stamp.value.toString() + '/' + name1 + '/';
      url_excel.value = base_url + '/file_download/1/' + stamp.value.toString() + '/' + name1 + '/';
      const formData = new FormData();
      formData.append("file", file_input.value);
      formData.append("stamp", stamp.value);
      dataRefreh();
      axios.post(base_url + '/uploadWord/', formData, {
        'Content-type': 'multipart/form-data'
      }).then(res => {
        clear();
        load1.value = false;

        if (res['data']['code'] === 200) {
          download_show.value = false;
          const time2 = Math.ceil((parseInt(Date.now()) - time1) / 60000);
          let estimate = res['data']['count'] * 3 - time2;

          ElMessageBox.alert(`${res['data']['count']}道题出题完成，为您节省了约${estimate}分钟。`, '成功', {
            confirmButtonText: '确定',
          });
        } else {
          ElMessageBox.alert('出错了', '失败', {
            confirmButtonText: '确定',
          });
        }

      }).catch(res => {
        console.log(res);
        clear();
        load1.value = false;
      });
    };

    const dataRefreh = () => {
      // 计时器正在进行中，退出函数
      if (intervalId.value != null) {
        return;
      }
      // 计时器为空，操作
      intervalId.value = setInterval(() => {
        //console.log(Date.now());
        setTimeout(getHeaderData(), 0);
      }, 3000);

    };

    const clear = () => {
      clearInterval(intervalId.value); //清除计时器
      intervalId.value = null; //设置为null
      file_progress.value = 'OK';

    };

    const getHeaderData = () => {
      axios.get(base_url + '/rwprocess/' + stamp.value.toString() + '/').then(res => {
        file_progress.value = res['data']['msg'];
      }).catch(res => {
        console.log(res['data']);
      });

    };

    return {
      base_url,
      problem,
      answer,
      file_input,
      word_upload,
      intervalId,
      title_msg,
      stamp,
      file_progress,
      url_word,
      url_excel,
      download_show,
      load1,
      btnSubmit,
      uploadAvatar,
      handleExceed,
      question_query
    }

  }
}
</script>

<style scoped>
.upload-demo {
  width: 30%;
  display: inline-block
}

.el-row {
  margin-top: 20px;
}
</style>